import emptySplitApi from "../utils/rtk";
import { CommonBody } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  statusCode: number;
  data: any;
  status: number;
  message: string;
  role: number;
};

export const subAdminApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    allsubAdmin: builder.query<
      CommonResponseType,
      { page: number; search: string; limit: number; }
    >({
      query: ({ page, search, limit }) => ({
        url: `${END_POINTS.subadmin}list/?page=${page}&search=${search}&limit=${limit}`,
        method: "GET",
      }),
    }),
    addSubAdmin: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.subadmin,
        method: "POST",
        body,
      }),

    }),
    deleteSubAdmin: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "DELETE",
      }),
    }),

    subAdminById: builder.query<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "GET",
      }),
    }),

    updateSubAdmin: builder.mutation<CommonResponseType, any>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});
export const {
  useLazyAllsubAdminQuery,
  useAddSubAdminMutation,
  useDeleteSubAdminMutation,
  useLazySubAdminByIdQuery,
  useUpdateSubAdminMutation,
} = subAdminApi;